import React from "react";

type NotesApi = { put: (url: string, body: unknown) => Promise<unknown> };

/**
 * Zustand der internen Notizen für den Block „Notizen“: Feld im Inhalt, „speichern“ im Kartenkopf —
 * beide Stellen teilen diesen Zustand.
 */
export function usePersonInternalNotes({ personId, internalNotes, api, onSaved, onSuccess }: {
  personId: string;
  internalNotes?: string | null;
  api: NotesApi;
  onSaved: (notes: string | null) => void;
  onSuccess: () => void;
}) {
  // Ein Entwurf gilt nur für den Stand, auf dem er begonnen wurde; ein neuer Serverwert ersetzt ihn.
  const [draft, setDraft] = React.useState<{ base: string; value: string } | null>(null);
  const [saving, setSaving] = React.useState(false);
  const base = internalNotes ?? "";
  const value = draft && draft.base === base ? draft.value : base;
  const setValue = React.useCallback((next: string) => setDraft({ base, value: next }), [base]);
  const save = React.useCallback(async () => {
    if (!personId || value === base) return;
    setSaving(true);
    try {
      const trimmed = value.trim();
      await api.put(`/api/v1/persons/${encodeURIComponent(personId)}/internal-notes`, { text: trimmed });
      setDraft(null);
      onSaved(trimmed || null);
      onSuccess();
    } catch {
      // Central API toast shows error
    } finally {
      setSaving(false);
    }
  }, [api, base, onSaved, onSuccess, personId, value]);
  return { value, setValue, save, saving, dirty: value !== base };
}
